import { Cigarette } from '@lt/widget/components/Cigarette';

export default Cigarette;
